import Element from '../../../Prototype/UI/Element';
import Game from '../../../Game';
import GameObject, { GameObjectEvent } from '../../../GameObject/GameObject';
import { applyDefaultButtonAnimation } from '../../../System/UI/UIHelper';
import { UIActions } from '../../../State/UI/UIActions';
import ButtonComponent from '../../../Component/UI/ButtonComponent';
import Renderable from '../../../Component/Renderable';
import { PopupID } from '../../../State/UI/PopupID';

export default class FriendsHubButton extends Element {
    public static _name: string;
    public static BTN_NAME: string = 'button';

    public create(params: any): void {
        FriendsHubButton._name = params.name;

        super.create({
            name: params.name,
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
                ...params.layout,
            },
            children: [
                {
                    name: 'button',
                    layout: {
                        anchors: [0.5, 0.5, 0.5, 0.5],
                        pivot: [0.5, 0.5],
                        offsets: [0, 0, 0, 0],
                        scale: [1, 1],
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'friends',
                            },
                        },
                        {
                            type: 'input',
                            data: {
                                enabled: true,
                                buttonMode: true,
                                toggleable: true,
                                tintOnDisable: true,
                            },
                        },
                    ],
                },
            ],
            ...params,
        });
        const button: GameObject = this.button;
        button.addComponent(ButtonComponent, {
            toggleable: true,
        });
        button.on(GameObjectEvent.SELECTED, this.onSelect.bind(this));
        applyDefaultButtonAnimation(button);

        if (Game.store.getState().playerState.settings.cinematicMode) {
            this.getComponent<Renderable>(Renderable).visible = false;
        }
    }

    private onSelect(): void {
        UIActions.showPopup(PopupID.FRIENDS_HUB, {});
    }

    public get button(): GameObject {
        return this.findChildByName(FriendsHubButton.BTN_NAME);
    }
}
